export enum MenuTypesEnum {
    ByFormat = 'byFormat',
    NoRGB = 'noRGB',
    RGB = 'RGB'
}
